import { getCountryFlagCode, getCountryFlagSrc } from "@/lib/countryFlags";
import { cn } from "@/lib/utils";

export const CountryFlag = ({
  code,
  name,
  className,
  imgClassName,
  size = 18,
  dataTestId,
}) => {
  const resolvedCode = getCountryFlagCode(code, name);
  const flagSrc = getCountryFlagSrc(code, name);

  if (!flagSrc) return null;

  return (
    <span
      className={cn("inline-flex shrink-0 items-center justify-center overflow-hidden rounded-sm border border-black/5 bg-white/70", className)}
      style={{ width: Math.round(size * 1.33), height: size }}
      data-testid={dataTestId}
      aria-hidden="true"
    >
      <img
        src={flagSrc}
        alt={`${name || resolvedCode} flag`}
        className={cn("block h-full w-full object-cover", imgClassName)}
        loading="lazy"
        draggable="false"
      />
    </span>
  );
};